import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../axios/axios";
import moment from "moment";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { DATE_TIME_FORMAT } from "../../constants/constants";
import { adminConfig } from "../../utils/adminConfig";

export default function ActiveReferralReports() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [csvData, setCsvData] = useState([]);

  const columns = [
    {
      name: "Name",
      selector: ({ userDetails }) => userDetails?.name,
      width: "300px",
    },
    {
      name: "Email",
      selector: ({ userDetails }) => userDetails?.email,
      width: "350px",
    },
    {
      name: "UserName",
      selector: ({ userDetails }) => userDetails?.userName,
      width: "350px",
    },
    {
      name: "Phone",
      selector: ({ userDetails }) => userDetails?.phone,
      width: "150px",
    },
    {
      name: "Address",
      selector: ({ userDetails }) => userDetails?.address,
      width: "350px",
    },
    {
      name: "Affiliate Code",
      selector: ({ code }) => code,
      width: "200px",
    },
    {
      name: "Active Affiliates",
      selector: ({ totalActiveAffiliates }) => totalActiveAffiliates,
      width: "150px",
    },
    {
      name: "Created At",
      selector: ({ userDetails }) =>
        moment(userDetails?.createdAt).format(DATE_TIME_FORMAT),
      width: "200px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "17px",
        color: "#004aad",
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "16px",
      },
    },
  };

  useEffect(() => {
    getAllActiveMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const getAllActiveMembers = () => {
    setLoading(true);
    axios
      .get(
        `/reports/active-referrals?source=tv&page=${page}&limit=${limit}&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/reports/csv-active-members?source=tv&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            Name: member.name,
            Email: member.email,
            UserName: member.userName,
            Phone: member.phone,
            Address: member.address,
            Country: member.country,
            CreatedAt: moment(member.createdAt).format("MM-DD-YYYY, h:mm a"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();

            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Name", key: "Name" },
    { label: "Email", key: "Email" },
    { label: "UserName", key: "UserName" },
    { label: "Phone", key: "Phone" },
    { label: "Address", key: "Address" },
    { label: "Country", key: "Country" },
    { label: "CreatedAt", key: "CreatedAt" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Active Referral Members</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group pl-0 col-md-4">
                    <div className="search_field w-100">
                      <input
                        placeholder="Type name or email or phone or username"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                      />
                      <Button
                        className="search_button"
                        variant="default"
                        onClick={() => {
                          setSearch(query);
                          setPage(1);
                        }}
                      >
                        <svg
                          width={20}
                          height={20}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.04 15.624a9.004 9.004 0 1 0-1.415 1.415l5.667 5.668a1 1 0 0 0 1.415-1.415l-5.668-5.668Zm-7.036 1.393a7.013 7.013 0 1 1 0-14.026 7.013 7.013 0 0 1 0 14.026Z"
                            fill="currentcolor"
                          />
                        </svg>
                      </Button>
                    </div>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`tv_active_members.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={members.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
